import { render, staticRenderFns } from "./SampleModule.vue?vue&type=template&id=52c402a0&scoped=true&"
import script from "./SampleModule.vue?vue&type=script&lang=js&"
export * from "./SampleModule.vue?vue&type=script&lang=js&"
import style0 from "./SampleModule.vue?vue&type=style&index=0&id=52c402a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c402a0",
  null
  
)

export default component.exports